import { newRequestMercurio } from "std/api/mercurio/newRequestMercurio";
import type { ApiBaseParams } from "std/api/types";

export type ApiCidadeGetParams = ApiBaseParams & {
	uf?: string;
	cidade?: string;
	cidade_nome_exato?: "S" | "N";
};

export type ApiCidade = {
	pais: ApiPais;
	cid_uf: string;
	cid_ibge: string;
	cid_idpk: number;
	cid_cidade: string;
	cid_timezone: string;
	cid_pais_idpk: number;
	cid_ultima_alteracao?: string;

	// se for informado total_registros nos params o primeiro item vai ter o total
	total_registros?: number;
};

export function apiCidadeGet({ idpk, params }: { idpk?: number; params?: ApiCidadeGetParams }): Promise<ApiCidade[]> {
	return newRequestMercurio({
		token: false,
		url: "Cidade/Cidade",
		type: "get",
		idpk,
		params,
	});
}

type ApiPaisGetParams = ApiBaseParams & {
	descricao?: string;
};

export type ApiPais = {
	pai_idpk: number;
	pai_descricao: string;
};

export function apiPaisGet(params?: ApiPaisGetParams): Promise<ApiPais[]> {
	return newRequestMercurio({
		token: false,
		url: "Pais/Consultar",
		type: "get",
		params,
	});
}
